"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadAppleSdk = void 0;
const loadAppleSdk = () => {
  if (typeof window !== "undefined" && typeof AppleID === "undefined") {
    const script = document.createElement("script");
    script.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
    script.crossOrigin = "anonymous";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }
};
exports.loadAppleSdk = loadAppleSdk;